
    import Vue from 'vue';

    const productMap: Record<string, string> = {
        'tecnologia': 'tecnologia',
        'movilidad': 'movilidad',
        'hogar-premium': 'hogar-premium',
    };

    export default Vue.extend({
        name: 'chatbot',
        busEvents: {
            'show-chat'(sitecode: number) {
                this.showChat = true;
                this.siteCode = sitecode;
            }
        },
        data() {
            return {
                showChat: false,
                siteCode: null,
                scrollY: 0,
            }
        },
        computed: {
            buttonStyle(): Record<string, string> {
                const initialTop = 90;
                const newTop = Math.max(-100, initialTop - this.scrollY);
                return {
                    position: 'fixed',
                    top: `${newTop}px`,
                    right: '20px',
                    zIndex: '99',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                };
            }
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            handleScroll() {
                this.scrollY = window.scrollY;
            },

            getProduct(): string | null {
                const segments = (this.$route && this.$route.path) ? this.$route.path.split('/').filter(Boolean) : [];
                const first = segments[0] || '';
                return productMap[first] || null;
            },

            openChat() {
                // abrir chat
                const chat = (this.$refs.chat as any);
                if (chat && typeof chat.show === 'function') {
                    try { chat.show(); } catch (e) { console.warn('nf-chat.show() error:', e); }
                }

                // payload a pushear
                const productValue = this.getProduct() || '';
                const payload = {
                    'event': 'cotizador-chat',
                    'product': productValue
                };

                // push
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                window.globalThis.dataLayer.push(payload);
            }
        }
    });
